__turbopack_context__.v({
  "close": "style-module-scss-module__zhv5jq__close",
  "image": "style-module-scss-module__zhv5jq__image",
});
